import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IAllContactsResponse, IContact } from "../models/Contact";
import { ISetting, ISettingsResponse, SettingType } from "../models/Setting";
import { useEffect, useState } from "react";

export default function useSettings() {
  const { get, post, put, del } = useApiHelper();
  const queryClient = useQueryClient();

  const [settings, setSettings] = useState<ISetting[]>([]);
  const [generalSettings, setGeneralSettings] = useState<ISetting[]>([]);
  const [shippingSettings, setShippingSettings] = useState<ISetting[]>([]);

  const settingsQuery = useQuery({
    queryKey: ["settings"],
    queryFn: () => get<ISettingsResponse>("/setting"),
  });

  useEffect(() => {
    if (settingsQuery.data && !settingsQuery.isLoading) {
      setSettings(settingsQuery.data.data);
      setGeneralSettings(settingsQuery.data.data.filter (s => s.settingType == SettingType.General));
      setShippingSettings(settingsQuery.data.data.filter(s => s.settingType == SettingType.Shipping));
    }
  }, [settingsQuery.data, settingsQuery.isLoading]);

  const create = useMutation(
    (setting: ISetting) => post("/setting", setting),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["settings"]);
      },
    }
  );
  
  const update = useMutation(
    (setting: ISetting) => put(`/setting/${setting.id}`, setting),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["settings"]);
      },
    }
  );

  return {
    loading: settingsQuery.isLoading,
    settings,
    generalSettings,
    shippingSettings,
    create,
    update,
  };
}
